import { render } from "./index.vue?vue&type=template&id=1ad5746a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1ad5746a&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad5746a"],['__file',"src/views/GrupoDeTarefas/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ad5746a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ad5746a', __exports__)) {
    console.log('reload')
    api.reload('1ad5746a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1ad5746a&scoped=true", () => {
    console.log('re-render')
    api.rerender('1ad5746a', render)
  })

}


export default __exports__